const announcementBanner = ($) => {

	const userHasClosedBanner = JSON.parse(localStorage.getItem('announcement-closed'));
	const lastMessageTimestamp = localStorage.getItem('announcement-timestamp');
	const currentMessageTimestamp = window.mainScript.bannerTimeStamp;

	// check if user has closed the banner before
	// banner will reappear if it is a new message
	if (userHasClosedBanner && lastMessageTimestamp === currentMessageTimestamp) {
		$('.announcement').addClass('announcement--close');
	}

	// click handler to hide the banner
	$('.js__announcement__button').on('click', function() {
		$('.announcement').addClass('announcement--close')
		localStorage.setItem('announcement-closed', true);
		localStorage.setItem('announcement-timestamp', currentMessageTimestamp);
	})
}

export default announcementBanner;
